import React, { useEffect, useState } from 'react';
import { Chip, Paper, Tooltip, Tabs, Tab } from "@mui/material"
import { Match, Game, Rank, Position, Placing, Diff, PlayerOwnership, PlacingWithCaptainVice, DiffWithCaptainsVice, Dismissal, Player, Over, SimplePlayer, StrikeStat } from "../../types/types"
import { GridColDef, GridRenderCellParams, selectedGridRowsCountSelector} from "@mui/x-data-grid"
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';

export const StrikeRateColumns:GridColDef[] = [
    { field: 'season', headerName: 'Season', width: 100 },
    { field: 'topSR', headerName: 'Top (1-7) SR', width: 200 },
    { field: 'midSR', headerName: 'Mid (7-14) SR', width: 200 },
    { field: 'endSR', headerName: 'End (15-20) SR', width: 200 },
    { field: 'avgSR', headerName: 'AVG SR' },
]

export interface Props {
    player: Player;
}


export default function StrikeRateTable({player}:Props)  {
    const [selectedPosition, setSelectedPosition ] = useState(0);
    const [rows, setRows ] = useState([]);
    console.log("strikerate:",player);
    function PopulateRows() {
        let datarows = [];
        //@ts-ignore
        let strikeStat:StrikeStat = {}
        if (selectedPosition === 0) {   
            strikeStat = player.batStrikeStat;  
        } else {
            strikeStat = player.bwlStrikeStat;  
        }

        //@ts-ignore
        datarows.push({
            id: "1",
            season: strikeStat.season,
            topSR: strikeStat.topSR,
            midSR: strikeStat.middleSR,
            endSR: strikeStat.endSR,
            avgSR: strikeStat.avgSR
        });

        setRows(datarows);
    }

    useEffect(() => {
        PopulateRows();
    },[player, selectedPosition])

     const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedPosition(newValue);
    };

    return (<div style={{display: "flex", flexDirection: "column", width: "100%"}}>
         <Tabs value={selectedPosition} onChange={handleChange} style={{marginBottom: "1rem"}} >
            <Tab label="Bat" />
            <Tab label="Bowl" />
        </Tabs>
        <Paper elevation={5}>
            <PlayerDataGrid height={150} columns={StrikeRateColumns} rows={rows} />
        </Paper>
    </div>)
}
